const produtos = angular.module('produtos', [])

produtos.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'admin.produtos',
            url: '/produtos',
            params: { showGlobalLoading: { dynamic: true, value: false } },
            component: 'produtos.produtosComponent'
        },
        {
            name: 'admin.editarProduto',
            url: '/produtos/:idProduto',
            params: { showGlobalLoading: { dynamic: true, value: false }, idProduto: null },
            component: 'produtos.produtoDetalhesComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);